function MediaController(){
	this.className			= "MediaController";
	this.debug				= false;
	this.glob				= "/**";
	this.level 				= 0;

	//this.currentVideoIndex 	= false;
	this.nextVideoIndex 	= false;
	this.isForcedPlaying 	= false;
	this.youtubeAPIReady 	= false;

	this.debugging 			= false;
};
MediaController.inheritsFrom( StandardController );
MediaController.prototype.swap = function( onComplete ){
	/*
	if(!this.isSetup) {
		this.setupPage();
		this.setupVideos();
	}
	this.init();
	*/

	return true;
}
MediaController.prototype.setupPage = function(){

	this.isSetup = true;

	// Elements
	this.$body 				= $("body");
	this.$header 			= this.$body.find('.js-site-header');
	this.$media				= this.$body.find(".js-media");

	//this.$media.add(this.$body.filter(".js-media"));

	// Vars
	this.videos 			= [];
	this.headerHeight 		= this.$header.outerHeight();
	this.loaderDuration 	= 1800;

	// Debounce
	this.checkVideosDebounced = Igloo.delegate(this,this.checkVideos);

	// Listeners
	this.onPlayListener = Igloo.delegate(this, this.onPlayListener);
	this.onProgressListener = Igloo.delegate(this, this.onProgressListener);
	this.scrollDelegate = jstage.addListener("scroll",this.checkVideosDebounced);
	this.onResizeDelegate = jstage.addListener("resize", Igloo.delegate(this, this.onResize));

	// Setup YouTube API callback.
	window.onYouTubeIframeAPIReady = Igloo.delegate(this, function(){
		if(this.debugging) Igloo.log("API Ready!");
		this.youtubeAPIReady = true;
		//this.checkVideos();
		this.setupYoutubeVideos();
	});

	// Create YouTube API script tag
	if(!document.getElementById('ytScriptTag')){
		var tag = document.createElement('script');
		tag.id = "ytScriptTag";
		tag.src = window.location.protocol + "//www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	// Create Vimeo API script tag
	/*if(!document.getElementById('vimeoScriptTag')){
		var tag = document.createElement('script');
		tag.id = "vimeoScriptTag";
		tag.src = "https://player.vimeo.com/api/player.js";
		var firstScriptTag = document.getElementsByTagName('link')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag.nextSibling);
	}*/
}

MediaController.prototype.setupVideos = function( onComplete ){
	var videos = [];
	var service = false;

	this.$media.each(Igloo.$delegate(this, function($this, index){
		var $elem = $this;
		var player = false;

		// Check streaming service.
		service = $elem.attr("data-service");
		var isVimeo = (service === 'vimeo');
		var isYouTube = (service === 'youtube');
		var isHTML5 = (!isYouTube && !isVimeo);

		var video = {
			index: 				index,
			id:					$elem.attr('data-id'),
			videoId:			$elem.attr("data-id"),
			title: 				$elem.attr("data-title"),
			service: 			service,
			type: 				'image',//($iframe ? 'video' : 'image'),
			autoplay: 			!($elem.attr("data-autoplay")*1),
			loop: 				!!($elem.attr("data-loop")*1),
			start: 				$elem.attr("data-start"),
			end: 				$elem.attr("data-end"),
			isManaged: 			!!($elem.attr('data-managed')*1),
			visible: 			$elem.attr('data-visible') ? !!($elem.attr('data-visible')*1) : true,
			loaded:				false,
			isYouTube: 			isYouTube,
			isVimeo: 			isVimeo,
			isHTML5: 			isHTML5,
			isMuted:			true,
			isPaused: 			false,
			isPlaying: 			false,
			isForcedPlaying: 	false,
			isInView: 			false,
			isMostlyInView: 	false,
			$elem: 				$elem,
			$iframe: 			false,//$iframe,
			$video: 			$elem.find(".js-media-video"),
			$poster: 			$elem.find(".js-media-poster"),
			$loader: 			$elem.find(".js-media-loader"),
			$controls: 			$elem.find(".js-controls"),
			$play: 				$elem.find(".js-play"),
			$pause: 			$elem.find(".js-pause"),
			$audio: 			$elem.find(".js-audio"),
			$mute: 				$elem.find(".js-mute"),
			$unMute: 			$elem.find(".js-unmute"),
			$fullscreen:		$elem.find(".js-fullscreen"),
			play:				Igloo.delegate(this,this.play,index),
			stop:				Igloo.delegate(this,this.stop,index),
			restart:			Igloo.delegate(this,this.restart,index),
			mute:				Igloo.delegate(this,this.mute,index),
			unMute:				Igloo.delegate(this,this.unMute,index),
			progress:			Igloo.delegate(this,this.progress,index),
		};

		// Control: Play button
		video.$play.on("click touchstart", Igloo.$d(this, function($this){
			video.play(true); //true makes it force play
		}));

		// Control: Audio button
		video.$audio.on("click touchstart", Igloo.$d(this, function($this){
			this.toggleAudio(video.index);
		}));

		videos.push(video);
	}));

	this.videos = videos;
	Igloo.log(this.videos);


	//this.setupYoutubeVideos();
	//this.setupVimeoVideos();
}

/*
 * Setup: Vimeo
 */
MediaController.prototype.setupVimeoVideos = function(  ) {
	if(!this.videos.length) return false;
	if(this.debugging) Igloo.log("Start loading vimeo videos.");

	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];
		if(video.service !== "vimeo") continue;
		if(!video.player){
			video.player = this.setupVimeoVideo(video);
		}
	}
}
MediaController.prototype.setupVimeoVideo = function( video ) {
	if(!video) return false;
	if(!video.$iframe || video.player) return false;

	var player = new Vimeo.Player(video.$iframe[0]);

	player.on("loaded", Igloo.delegate(this, function(data){
		video.loaded = true;
		if(this.debugging) Igloo.log('Vimeo Ready Event', data);
		player.setLoop(video.loop);
		this.checkVideos();
	}));

	player.on('play', Igloo.delegate(this, function( data ){
		video.isActuallyPlaying = true;

		// Hide loader
		if(video.$loader) video.$loader.fadeOut(this.loaderDuration);
	}));

	player.on('progress', Igloo.delegate(this, function( data ){

	}));

	return player;
}

/*
 * Setup: YouTube
 */
MediaController.prototype.setupYoutubeVideos = function(  ) {
	if(!this.videos.length) return false;
	if(!this.youtubeAPIReady) return false;
	if(this.debugging) Igloo.log("Start loading youtube videos.");

	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];
		if(!video.isYouTube) continue;
		if(!video.player){
			video.player = this.setupYoutubeVideo(video);
		}
	}

	// Recheck videos.
	this.checkVideos();
}
MediaController.prototype.setupYoutubeVideo = function( video ) {
	if(!video) return false;
	if(!video.$iframe || video.player) return false;
	if(!this.youtubeAPIReady) return false;


	var onPlayerReady = Igloo.delegate(this, function( event ) {
		video.loaded = true;
		//document.getElementsByClassName("ytp-pause-overlay ytp-scroll-min")[0].style.display = 'none';
		if(this.debugging) Igloo.log('YouTube Ready Event', event);
		this.checkVideos();
	});

	var onPlaybackQualityChange = Igloo.delegate(this, function( e ) {
		//Igloo.log("Set playback quality:", e.data);
	});

	var onPlayerStateChange = Igloo.delegate(this, function( e ) {
		// STATE: ENDED
		if (video.loop && e.data === YT.PlayerState.ENDED) {
			video.restart();
		}

		// STATE: STOPPED
		/*
		if (e.data == YT.PlayerState.PAUSED || e.data == YT.PlayerState.ENDED) {
			if(video.videoInterval) clearInterval(video.videoInterval);
		}
		*/

		// STATE: BUFFERING
		if (e.data === YT.PlayerState.BUFFERING){}

		// Hide loader
		if(e.data === YT.PlayerState.PLAYING && video.$loader && video.isActuallyPlaying){
			video.videoInterval = setInterval(video.progress,100);
			video.$loader.fadeOut(this.loaderDuration);
		}
	});

	var onPlayerError = Igloo.delegate(this, function( event ) {
		video.loaded = false;
		//Igloo.log(event);
	});

	var player = new YT.Player(video.videoId, {
		videoId: video.id,
		playerVars: {
			'modestbranding': 1,
			'autoplay': 0,
			'loop': video.loop,
			'controls': 0,
			'showinfo': 0,
			'ytp-pause-overlay': 0,
			'rel': 1,
			'iv_load_policy': 3,
			'origin': window.location.protocol + "//" + window.location.hostname,
		},
		events: {
			'onReady': onPlayerReady,
			'onStateChange': onPlayerStateChange,
			'onPlaybackQualityChange': onPlaybackQualityChange,
			'onError': onPlayerError,
		}
	});

	return player;
}


MediaController.prototype.init = function(  ) {
	if(this.debugging) Igloo.log("Check videos and play");
	this.checkVideos();
	this.positionCoverVideos();
}
MediaController.prototype.checkVideos = function(  ) {
	if(!this.videos.length) return false;

	// Scroll
	var st = jstage.getScroll();

	// Loop videos and check if any are in view.
	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];

		// Offsets
		var centreOfBrowser = (st + jstage.getHeight() / 2);
		video.width = video.$elem.width();
		video.height = video.$elem.height();
		video.top = video.$elem.offset().top;
		video.bottom = (video.top + video.$elem.outerHeight());
		video.centre = (video.top + video.bottom)/2;
		video.distance = Math.abs(centreOfBrowser - video.centre);
		//Igloo.log(video.title + " Distance: " + video.distance);

		video.isInView = (video.bottom > (st+this.headerHeight) && video.top < st + jstage.getHeight());
		video.isMostlyInView = (video.centre > (st+this.headerHeight) && video.centre < st + jstage.getHeight());
		video.visible = (video.$elem.attr('data-visible') ? !!(video.$elem.attr('data-visible')*1) : true);

		// Load iframe if close enough
		if(!video.$iframe) this.loadIframe(video);

		// Load player if not loaded already
		if(video.player) continue;
		if(video.isVimeo) video.player = this.setupVimeoVideo(video); // Load Vimeo player
		else if(video.isYouTube) video.player = this.setupYoutubeVideo(video); // Load YouTube player
		else video.player = video.$elem[0];
	}

	this.updateVideos();
}
MediaController.prototype.updateVideos = function() {

	// Clone array and sort by distance.
	var videos = Igloo.clone(this.videos,false);
	videos.sort( this.sortByDistance );


	//Igloo.log(videos);
	this.videosSortedByDistance = videos;

	// Preload next video.
	this.preloadNext();

	// Get next video
	var firstVisibleVideo = Igloo.searchArray(videos,"visible",true);
	this.nextVideoIndex = firstVisibleVideo.index;

	// Stop all videos unless next is current.
	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];

		if(video.isForcedPlaying && !video.isInView){
			video.stop(true);
			//Igloo.log("Force stop next video");

		}else if(!video.isMostlyInView){
			video.stop();

		}else{
			if(video.index === this.nextVideoIndex){
				if(this.debugging) Igloo.log("Play next video player", video);
				if(video.isMuted) video.mute();
				if(video.autoplay) video.play();
			}
		}
	}
}
MediaController.prototype.preloadNext = function( ) {
	for(var i = 0; i < this.videosSortedByDistance.length; i++){
		var v = this.videosSortedByDistance[i];
		if(!v.preloaded){
			this.preload(v);
			break;
		}
	}
}
MediaController.prototype.preload = function( video ) {
	if(!video.player) return false;
	if(video.preloaded) return this.preloadNext();
	if(video.preloading) return false;

	if(video.isYouTube && video.loaded){
		video.player.playVideo();
		if(!video.isPlaying){
			video.player.pauseVideo();
		}
		video.preloading = false;
		video.preloaded = true;
		this.preloadNext();

	}

	if(video.isVimeo && video.loaded){
		video.player.play().then(Igloo.delegate(this, function(){
			if(!video.isPlaying){
				video.player.pause();
			}
			video.preloading = false;
			video.preloaded = true;
			this.preloadNext();
		}));

	}

	if(video.isHTML5 && video.loaded){
		if(!video.isPlaying){
			video.player.pause();
		}
		video.preloading = false;
		video.preloaded = true;
		this.preloadNext();
	}
}
MediaController.prototype.play = function( index, force ) {
	var video = this.getVideo(index);
	if(!video.player) return;

	// console.log("play");
	video.player.play();

	if(force){
		this.stopAll(true)
		this.isForcedPlaying = true;
		video.isForcedPlaying = true;
	}

	if(video.isPlaying || !video.loaded) return false;
	if(!force && this.isForcedPlaying) return false;

	this.stopAll();

	this.currentVideoIndex = index;

	// Play video
	video.isPlaying = true;
	video.isPaused = false;
	video.$elem.addClass('is-playing');

	// Show iframe
	if (video.$iframe) video.$iframe.css({visibility: "visible", opacity: 1});

	this.playMedia(index);

	// Fade out play button
	video.$play.stop().animate({opacity: 0}, 1000, function(){ video.$play.hide(); });

	// Fade out image after 200ms.
	video.hideTimeout = setTimeout(function() {
		if(this.debugging) Igloo.log("Is playing:", video.isPlaying);
		if(video.$poster && video.isPlaying){
			video.$poster.stop().animate({opacity: 0}, 2000, Igloo.$delegate(this,function($this){
				$this.hide();
				video.$play.hide();
			}));
		}
	}, 800);
}
MediaController.prototype.stop = function( index, force ) {
	var video = this.getVideo(index);
	if(!video.player) return;

	if(force){
		this.isForcedPlaying = false;
		video.isForcedPlaying = false;
	}

	if(!video.isPlaying) return false;
	if(video.isForcedPlaying && !force) return false;

	this.currentVideoIndex = false;

	// Pause video
	video.isPlaying = false;
	video.isPaused = true;
	video.$elem.removeClass('is-playing');

	clearTimeout(video.hideTimeout);

	// Fade in play button
	video.$play.stop().show().animate({opacity: 1}, 1000);

	// Fade in poster if not hidden.
	if(video.$poster){
		video.$poster.stop().show().animate({opacity: 1}, 1000);
	}

	// Pause player
	this.pauseMedia(index);

}
MediaController.prototype.stopAll = function(force) {
	if(!this.videos?.length) return false;

	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];
		video.stop(force);
	}
}
MediaController.prototype.toggleAudio = function( index ) {
	var video = this.getVideo(index);
	if(!video.player) return;

	if(video.isMuted){
		this.unMute(video.index);
		return;
	}

	this.mute(video.index);
}
MediaController.prototype.mute = function( index ) {
	var video = this.getVideo(index);
	if(!video.player) return;

	video.isMuted = true;

	video.$mute.removeClass('show');
	video.$unMute.addClass('show');

	if(video.isYouTube && video.loaded){
		video.player.mute();
	}

	if(video.isVimeo && video.loaded){
		video.player.setVolume(0);
	}

	if(video.isHTML5 && video.loaded){
		video.player.unMute();
	}

	this.fire("toggleAudio",{muted:true, video: video});
}
MediaController.prototype.unMute = function( index ) {
	var video = this.getVideo(index);
	if(!video.player) return;

	video.isMuted = false;
	
	video.$unMute.removeClass('show');
	video.$mute.addClass('show');

	if(video.isYouTube && video.loaded){
		video.player.unMute();
	}

	if(video.isVimeo && video.loaded){
		video.player.setVolume(1);
	}

	if(video.isHTML5 && video.loaded){
		video.player.unMute();
	}

	this.fire("toggleAudio",{muted:false, video: video});
}
MediaController.prototype.pauseMedia = function(index) {
	var video = this.getVideo(index);
	if(!video.player) return;

	if(video.isYouTube && video.loaded){
		video.player.pauseVideo();
		video.isActuallyPlaying = false;
	}

	if(video.isVimeo && video.loaded){
		video.player.pause().then(function(){
			video.isActuallyPlaying = false;
		});
	}

	if(video.isHTML5 && video.loaded){
		video.player.pause().then(function(){
			video.isActuallyPlaying = false;
		});
	}

	video.isActuallyPlaying = false;
};
MediaController.prototype.playMedia = function(index) {
	var video = this.getVideo(index);
	if(!video.player) return;

	if(video.isYouTube && video.loaded){
		// YOUTUBE
		if(video.start) video.player.seekTo(video.start, true);
		//video.player.setPlaybackQuality("highres");
		video.player.playVideo();
		video.isActuallyPlaying = true;
	}

	if(video.isVimeo && video.loaded){
		// VIMEO
		video.player.play().then(function(){
			if(video.start) video.player.setCurrentTime(video.start);
			video.isActuallyPlaying = true;
		});
	}

	if (video.isHTML5 && video.loaded) {
		// HTML5
		console.log("Play");
		video.player.play();
	}
}
MediaController.prototype.progress = function(index) {
	var video = this.getVideo(index);
	if(!video.player) return;

	var videoTime = video.player.getCurrentTime();
	if(videoTime && videoTime >= video.end) {
		//Igloo.log("the video reached "+ video.end +" seconds, restart!");
		if(video.videoInterval) clearInterval(video.videoInterval);
		video.restart();
	}
	//Igloo.log(videoTime);
}
MediaController.prototype.restart = function(index) {
	var video = this.getVideo(index);
	if(!video.player) return;
	video.stop();
	video.player.seekTo(0);
	video.play();
}

MediaController.prototype.fullscreen = function( elem ) {
	if (elem.requestFullscreen) {
		elem.requestFullscreen();
	} else if (elem.msRequestFullscreen) {
		elem.msRequestFullscreen();
	} else if (elem.mozRequestFullScreen) {
		elem.mozRequestFullScreen();
	} else if (elem.webkitRequestFullscreen) {
		elem.webkitRequestFullscreen();
	}
}

/*
 * Load player api
 */
MediaController.prototype.loadPlayerAPI = function( player ) {
	if(!this.videos.length) return false;

	var src = false;

	var domainProtocol = window.location.protocol;

	if(player == "vimeo") 			src = domainProtocol + "//player.vimeo.com/api/player.js";
	else if(player == "youtube")	src = domainProtocol + "//www.youtube.com/iframe_api";

	var tag = document.createElement('script');
	tag.src = src;
	tag.id = "youtube";
	// tag.id = player;
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

/*
 * Load video iframe
 */
MediaController.prototype.loadIframe = function( video ){
	if(!video) return false;
	if(video.$iframe) return video.$iframe;

	// Get iframe holder
	var $iframeHolder = video.$elem.find(".js-iframe");
	if(!$iframeHolder.length) return;

	// Get all iframe attributes from holder
	var iframeAttrs = $iframeHolder[0].attributes;

	var attrs = [];
	for(var i=0; i<iframeAttrs.length; i++){
		var attr = iframeAttrs[i];
		var key = attr.name;
		var dataString = "data-";
		if(key.indexOf(dataString) === -1) continue;
		attrs[key.substring(dataString.length)] = attr.value;
	}

	// Create iframe data string
	var attrString = "";
	for(var key in attrs){
		attrString += key +'="'+ attrs[key] +'" ';
	}

	// Create iframe and replace holder
	var $iframe = $("<iframe "+ attrString +"></iframe>");
	$iframeHolder.replaceWith($iframe);

	video.$iframe = video.$elem.find('iframe');
	video.type = 'iframe';
	//$iframe.load(Igloo.delegate(this, function(){}));
}

MediaController.prototype.getVideo = function( index ) {
	if(typeof(index) == "undefined") return false;
	return index in this.videos ? this.videos[index] : false;
}

MediaController.prototype.sortByDistance = function( a, b ) {
	if ( a.distance < b.distance ){ return -1; }
	if ( a.distance > b.distance ){ return 1; }
	return 0;
}

MediaController.prototype.onResize = function(){
	this.headerHeight = this.$header.outerHeight();
	this.checkVideos();
	this.positionCoverVideos();
}

MediaController.prototype.positionCoverVideos = function(){
	for(var i=0; i<this.videos.length; i++){
		var video = this.videos[i];
		if(!video || !video.$video) continue;

		var videoClass = video.$video.attr('class');
		if(videoClass === undefined) continue;
		var videoClasses = videoClass.split(/\s+/);

		var aspectRatio, letterboxAspectRatio, pillarboxAspectRatio;
		var containerAspectRatio = (video.height/video.width);

		aspectRatio = 9/16;

		for(var x=0; x<videoClasses.length; x++){
			var videoClass = videoClasses[x];

			if(videoClass == "ratio-classic"){
				aspectRatio = 3/4;
			}

			if(videoClass == "ratio-standard"){
				aspectRatio = 9/16;
			}

			if(videoClass == "ratio-pillarbox"){
				pillarboxAspectRatio = 720/1120;
			}

			if(videoClass == "ratio-letterbox"){
				letterboxAspectRatio = 640/1280;
			}

			if(videoClass == "ratio-letterbox-large"){
				letterboxAspectRatio = 528/1260;
			}

		}

		if(!letterboxAspectRatio) letterboxAspectRatio = aspectRatio;
		if(!pillarboxAspectRatio) pillarboxAspectRatio = aspectRatio;

		var letterboxHeightFactor = aspectRatio / letterboxAspectRatio;
		var pillarboxWidthFactor = aspectRatio * pillarboxAspectRatio;

		var constrain = (letterboxAspectRatio < containerAspectRatio || pillarboxAspectRatio < containerAspectRatio) ? 'height' : 'width';

		var newWidth, newHeight;
		//Igloo.log("Constrain" + constrain);
		if(constrain == "height"){
			newHeight = video.height * letterboxHeightFactor;
			newWidth = newHeight / aspectRatio;
		}else{
			newWidth = video.width / pillarboxWidthFactor;
			newHeight = newWidth * aspectRatio;
		}

		video.$video.css({width:newWidth, height:newHeight});
	}

}


MediaController.prototype.off = function(  ) {
	this.isSetup = false;

	if(this.scrollDelegate) jstage.removeListener("scroll",this.scrollDelegate);
	if(this.onResizeDelegate) jstage.removeListener("resize",this.onResizeDelegate);
	this.stopAll();

	// Destroy head items
	/*
	if ($('head script[id="youtube"]').length > 0){
		(elem=document.getElementById("youtube")).parentNode.removeChild(elem)
	}
	*/
	// document.removeEventListener("touchstart",this.touchstartDelegate,{passive:false});
};
